/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_Insert_Aria_LabelInputs */

const en_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert event template`)
};

const fr_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer le modele d'evenement`)
};

const de_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisvorlage einfügen`)
};

const it_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci modello evento`)
};

const ru_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить шаблон события`)
};

const es_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar plantilla de evento`)
};

const zh_cn2_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入事件模板`)
};

const ja_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテンプレートを挿入`)
};

const hi_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेम्पलेट डालें`)
};

const pt_pt2_event_templates_insert_aria_label = /** @type {(inputs: Event_Templates_Insert_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir modelo de evento`)
};

/**
* | output |
* | --- |
* | "Insert event template" |
*
* @param {Event_Templates_Insert_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_insert_aria_label = /** @type {((inputs?: Event_Templates_Insert_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Insert_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_templates_insert_aria_label(inputs)
	if (locale === "de") return de_event_templates_insert_aria_label(inputs)
	if (locale === "it") return it_event_templates_insert_aria_label(inputs)
	if (locale === "ru") return ru_event_templates_insert_aria_label(inputs)
	if (locale === "es") return es_event_templates_insert_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_templates_insert_aria_label(inputs)
	if (locale === "ja") return ja_event_templates_insert_aria_label(inputs)
	if (locale === "hi") return hi_event_templates_insert_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_templates_insert_aria_label(inputs)
	return en_event_templates_insert_aria_label(inputs)
});